import _ from 'lodash';

const actionTypes = {
  PUSH_VIEW: 'PUSH_VIEW',
  POP_VIEW: 'POP_VIEW',
  RESET_VIEW: 'RESET_VIEW',
  CLOSE_VIEW: 'CLOSE_VIEW',
};

export const CONTAINERS = {
  MAP_VIEW: 'MAP_VIEW',
  GRID_VIEW: 'GRID_VIEW',
  SCHEDULER_VIEW: 'SCHEDULER_VIEW',
  REQUEST_VIEW: 'REQUEST_VIEW',
  TASK_VIEW: 'TASK_VIEW',
};

const initialState = {
  [CONTAINERS.MAP_VIEW]: {
    viewStack: [],
  },
  [CONTAINERS.GRID_VIEW]: {
    viewStack: [],
  },
  [CONTAINERS.SCHEDULER_VIEW]: {
    viewStack: [],
  },
  [CONTAINERS.REQUEST_VIEW]: {
    viewStack: [],
  },
  [CONTAINERS.TASK_VIEW]: {
    viewStack: [],
  },
};

export function pushView(container, view) {
  return { type: actionTypes.PUSH_VIEW, view, container };
}

export function popView(container) {
  return { type: actionTypes.POP_VIEW, container };
}

export function resetView(container, view) {
  return { type: actionTypes.RESET_VIEW, view, container };
}

export function closeView(container) {
  return { type: actionTypes.CLOSE_VIEW, container };
}

export default function cardNavigationReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLOSE_VIEW: {
      return { ...state, [action.container]: { viewStack: [] } };
    }
    case actionTypes.RESET_VIEW: {
      action.view.props = action.view.props || {};
      action.view.props.container = action.container;
      return { ...state, [action.container]: { viewStack: [action.view] } };
    }
    case actionTypes.POP_VIEW: {
      const clonedViewStack = [...state[action.container].viewStack];
      clonedViewStack.splice(clonedViewStack.length - 1, 1);
      return { ...state, [action.container]: { viewStack: clonedViewStack } };
    }
    case actionTypes.PUSH_VIEW: {
      const currentView = state[action.container].viewStack[state[action.container].viewStack.length - 1];
      action.view.props = action.view.props || {};
      action.view.props.container = action.container;
      // if same component is being pushed, it doesn't make change
      if (
        currentView &&
        currentView.component === action.view.component &&
        _.isEqual(currentView.props, action.view.props)
      ) {
        return state;
      }
      const viewStack = [...state[action.container].viewStack, action.view];
      return { ...state, [action.container]: { viewStack } };
    }
    default: {
      return state;
    }
  }
}

export const getCurrentViewSelector = (container) => (state) =>
  state.cardNavigationReducer[container].viewStack[state.cardNavigationReducer[container].viewStack.length - 1];

export const getPreviousViewSelector = (container) => (state) =>
  state.cardNavigationReducer[container].viewStack[state.cardNavigationReducer[container].viewStack.length - 2];
